var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1196",
    "data-name": "Groupe 1196",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_260",
    "data-name": "Groupe 260",
    transform: "translate(3.733 3.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_240",
    "data-name": "Trac\\xE9 240",
    d: "M18.467,18.2H7.267a.666.666,0,0,1-.667-.667V10.067A.666.666,0,0,1,7.267,9.4h11.2a.666.666,0,0,1,.667.667v7.467A.666.666,0,0,1,18.467,18.2ZM7.933,16.867H17.8V10.733H7.933Z",
    transform: "translate(-6.6 -9.4)",
    fill: "#19c3b9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_261",
    "data-name": "Groupe 261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_241",
    "data-name": "Trac\\xE9 241",
    d: "M1.667,9.067A.666.666,0,0,1,1,8.4V4.667A.666.666,0,0,1,1.667,4H5.4a.667.667,0,1,1,0,1.333H2.333V8.4A.666.666,0,0,1,1.667,9.067Z",
    transform: "translate(-1 -4)",
    fill: "#19c3b9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_262",
    "data-name": "Groupe 262",
    transform: "translate(14.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_242",
    "data-name": "Trac\\xE9 242",
    d: "M27.8,9.067a.666.666,0,0,1-.667-.667V5.333H24.067a.667.667,0,1,1,0-1.333H27.8a.666.666,0,0,1,.667.667V8.4A.666.666,0,0,1,27.8,9.067Z",
    transform: "translate(-23.4 -4)",
    fill: "#19c3b9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_263",
    "data-name": "Groupe 263",
    transform: "translate(0 10.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_243",
    "data-name": "Trac\\xE9 243",
    d: "M5.4,25.467H1.667A.666.666,0,0,1,1,24.8V21.067a.667.667,0,1,1,1.333,0v3.067H5.4a.667.667,0,0,1,0,1.333Z",
    transform: "translate(-1 -20.4)",
    fill: "#19c3b9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_264",
    "data-name": "Groupe 264",
    transform: "translate(14.933 10.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_244",
    "data-name": "Trac\\xE9 244",
    d: "M27.8,25.467H24.067a.667.667,0,1,1,0-1.333h3.067V21.067a.667.667,0,1,1,1.333,0V24.8A.666.666,0,0,1,27.8,25.467Z",
    transform: "translate(-23.4 -20.4)",
    fill: "#19c3b9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/scanner.dad7f7682ca3ee5436ae13bde8b8b4ce.svg";
export { ForwardRef as ReactComponent };